import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { isEmpty } from 'lodash';
import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import Alert from 'components/ui/Alert';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
const DATE_FORMAT = 'L';
function getMomentDate(date) {
    if (!date) {
        return null;
    }
    return moment(date);
}
class LogPaymentModal extends Component {
    constructor(props) {
        super(props);
        this.onDateSelect = (transactionDate) => {
            this.setState({ transactionDate });
        };
        this.onPaymentSelect = (selected) => {
            const { value: paymentMethod } = selected;
            this.setState({ paymentMethod });
        };
        this.handleSave = () => {
            const { t } = this.props;
            const trimmedTransactionId = this.state.transactionId.trim();
            if (isEmpty(trimmedTransactionId)) {
                return this.setState({
                    error: t('TRANSACTION_ID_ERROR'),
                });
            }
            if (!this.state.transactionDate) {
                return this.setState({
                    error: t('TRANSACTION_DATE_ERROR'),
                });
            }
            const { amount, transactionId, transactionDate, paymentMethod } = this.state;
            this.props.onSave({
                amount,
                transactionId,
                transactionDate,
                paymentMethod,
            });
            this.setState(this.clearState());
            this.props.onHide();
        };
        this.state = this.getInitialState(props);
    }
    getInitialState(props) {
        return {
            error: null,
            amount: props.amount,
            paymentMethod: '',
            transactionId: '',
            transactionDate: '',
        };
    }
    clearState() {
        return {
            error: null,
            amount: '',
            paymentMethod: '',
            transactionId: '',
            transactionDate: '',
        };
    }
    onChange(key) {
        return (value) => {
            this.setState({ [key]: value });
        };
    }
    renderError() {
        if (!this.state.error) {
            return null;
        }
        return React.createElement(Alert, { dataTestId: "Alert-588839ea", type: "error" }, this.state.error);
    }
    render() {
        const { t } = this.props;
        const paymentMethods = [
            {
                name: t('CHECK'),
                value: 'check',
            },
            {
                name: t('MANUAL'),
                value: 'manual',
            },
        ];
        return ((React.createElement(Modal, { show: this.props.show, onHide: this.props.onHide, enforceFocus: false },
            React.createElement(Modal.Header, { "data-testid": "undefined-b6c3fab6" },
                React.createElement("strong", { "data-testid": "strong-55968fa3" }, t('LOG_A_PAYMENT'))),
            React.createElement(Modal.Body, { "data-testid": "undefined-a6d26f09" },
                this.renderError(),
                React.createElement("div", { "data-testid": "div-49550896", className: "grid grid-cols-2 gap-4" },
                    React.createElement(CargomaticInput, { dataTestId: "CargomaticInput-9438dec6", name: "amount", value: this.state.amount, onChange: this.onChange('amount'), type: "text", label: t('AMOUNT'), className: "mb-4", placeholder: t('AMOUNT'), disabled: true }),
                    React.createElement(CargomaticSelect, { dataTestId: "CargomaticSelect-b294f2b6", label: t('PAYMENT_METHOD'), items: paymentMethods, onSelect: this.onPaymentSelect, value: this.state.paymentMethod, className: "mb-4", textKey: "name", valueKey: "value", placeholder: t('PAYMENT_METHOD'), showCaption: true }),
                    React.createElement(CargomaticInput, { dataTestId: "CargomaticInput-30e16eea", name: "transactionId", value: this.state.transactionId, onChange: this.onChange('transactionId'), type: "text", label: t('TRANSACTION_ID_LABEL'), className: "mb-4", placeholder: t('TRANSACTION_ID') }),
                    React.createElement("div", { "data-testid": "div-3f2ed167", className: "mb-4" },
                        React.createElement("label", { "data-testid": "label-4ad25449", htmlFor: "startDate", className: "block mb-1 form-label" }, t('TRANSACTION_DATE')),
                        React.createElement(DatePicker, { id: "transactionDate", name: "transactionDate", selected: getMomentDate(this.state.transactionDate), onChange: this.onDateSelect, className: "form-field", dateFormat: DATE_FORMAT, shouldCloseOnSelect: true, placeholderText: t('TRANSACTION_DATE') })))),
            React.createElement(Modal.Footer, { "data-testid": "undefined-874bba23" },
                React.createElement("button", { "data-testid": "button-99e58e3a", className: "button button-green", type: "button", onClick: this.handleSave }, titleize(t('SAVE'))),
                React.createElement("button", { "data-testid": "button-4599e9ff", className: "button button-secondary", type: "button", onClick: this.props.onHide }, titleize(t('CLOSE')))))));
    }
}
export default withTranslation()(LogPaymentModal);
